module.exports = __webpack_public_path__ + "media/images/favicons/android-chrome-256x256-a5a32ed3ec16df8895e7de33bdd01fa2.png";